import axios from "axios";

const backendUrl= process.env.REACT_APP_BACKEND_URL
const LOGIN=`${backendUrl}/auth/login`
const LOGOUT=`${backendUrl}/auth/logout`
const FORGOT_PASSWORD=`${backendUrl}/auth/forgot-password`
const RESET_PASSWORD=`${backendUrl}/auth/reset-password`
const tokenType = "Bearer"

const recaptchaDisable = process.env.REACT_APP_RECAPTHCA_DISABLE?.toLowerCase() === "true";

export const login=async(email, password, recaptcha_token) =>{
    const res = await axios.post(LOGIN,
      {
        email,
        password,
        recaptcha_token: !recaptchaDisable ? recaptcha_token : undefined
      },
    );
    return res
  }

  export const logout=async(refreshToken) =>{
    const res = await axios.post(LOGOUT,
      {
        refreshToken
      },
    );
    return res
  }


  export const forgotPassword=async(email,recaptcha_token) =>{
    const res = await axios.post(FORGOT_PASSWORD,
      {
        email,
        recaptcha_token: !recaptchaDisable ? recaptcha_token : undefined
      },
    );
    return res
  }
  export const resetPassword=async(token,password,recaptcha_token) =>{
    const res = await axios.post(`${RESET_PASSWORD}?token=${token}`,
      {
        password,
        recaptcha_token: !recaptchaDisable ? recaptcha_token : undefined
      },
    );
    return res
  }